import mobileAds, {
  RewardedAd,
  AdsConsent,
} from 'react-native-google-mobile-ads';
import * as TrackingTransparency from 'expo-tracking-transparency';
import { observable, action } from 'mobx';

import { IS_IOS, IS_WEB } from './appConstants';

const AD_UNIT_REWARDED =
  IS_IOS
    ? 'ca-app-pub-8341905232735299/8586278087'
    : 'ca-app-pub-XXXXXXXXXXXXXXXX/ANDROID_REWARDED_UNIT_ID';

class AdsStore {
  @observable adsReady = false;
  private rewarded: RewardedAd | null = null;

  @action
  async init() {
    if (IS_WEB) return;
    try {
      await mobileAds().initialize();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('adsStore.init AdMob initialize failed:', e);
      this.adsReady = false;
      return;
    }
    // GDPR/UMP consent must run BEFORE ATT so the user's ATT choice is the
    // final word on tracking (App Store guideline 5.1.1(iv)).
    try {
      const consent = await AdsConsent.requestInfoUpdate();
      if (consent.isConsentFormAvailable) {
        await AdsConsent.loadAndShowConsentFormIfRequired();
      }
    } catch (e) {
      // UMP not configured / unreachable — AdMob still serves non-personalized ads.
      // eslint-disable-next-line no-console
      console.warn('adsStore.init UMP step failed (continuing):', e);
    }
    if (IS_IOS) {
      try {
        await TrackingTransparency.requestTrackingPermissionsAsync();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('adsStore.init ATT request failed (continuing):', e);
      }
    }
    this.adsReady = true;
  }

  loadRewarded(): RewardedAd {
    if (!this.rewarded) {
      this.rewarded = RewardedAd.createForAdRequest(AD_UNIT_REWARDED);
    }
    this.rewarded.load();
    return this.rewarded;
  }

  consumeRewarded() {
    this.rewarded = null;
  }
}

export default new AdsStore();
